import { FileStorageService } from './FileStorageService';

export { FileStorageService } from './FileStorageService';
export * from './types';

// Singleton instance
export const fileStorageService = new FileStorageService();